import { Injectable } from '@angular/core';
import {Http, RequestOptions, Response} from "@angular/http";
import {environment} from "../../environments/environment";

@Injectable()
export class FormsService {

  constructor(
    private http: Http,
  ) { }

  private baseUrl: string = environment.lambdaApi;
  private headers: any;
  private options: any;

  getAllForms(propertySoftware, locationKey, clientCode) {
    if(propertySoftware == 'sitelink')
      var url = this.baseUrl + 'forms-retrieve';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.post(url, {
      "clientCode": clientCode,
      "locationKey": locationKey,
      "env": environment.env
    }, this.options).map((res: Response) => res.json());
  }


  getObjectFromFirebase(table, clientCode) {
    const url = this.baseUrl + 'get-object-from-firebase';
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    const options = new RequestOptions({headers: this.headers});
    return this.http.post(url, {
      "apiUrl": url,
      "table": table,
      "clientCode": clientCode
    }, options).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/forms.service.ts